import React, { useState } from "react";
import ReportModalDateRange from "../ReportModalDateRange/ReportModalDateRange";
import { ReportAction, ReportType } from "../../../utils/enums";
import { GIFT_CARD_REPORT } from "../../../store/reducers/restaurant/restaurant-actions";
import ExportFileControl from "../ExportFileControl/ExportFileControl";

const GiftCardReportControl = () => {
    const [isOpenForm, setIsOpenForm] = useState(false);

    return (
        <ExportFileControl
            canSavePdfReport
            hideExelReport
            control={{ reportType: ReportType.MarketplaceGiftCards, reportAction: ReportAction.Get, action: GIFT_CARD_REPORT, actionFn: () => setIsOpenForm(true) }}
            FilterForm={ReportModalDateRange}
            filterFormProps={{
                isOpen: isOpenForm,
                setIsOpen: setIsOpenForm,
            }}
        />
    )
}

export default GiftCardReportControl;